<div #inputElement
     tabindex="0"
     [class.disabled]="disabled"
     [class.hide-date-icon]="!!value"
     (click)="!disabled && picker.open()"
     (keypress)="onKeyPress($event)"
     (keydown)="onKeydown($event)">
    <div>
        <md2-datepicker #picker
                        mode="portrait"
                        [placeholder]="label"
                        [min]="min"
                        [max]="max"
                        [type]="type"
                        [disabled]="disabled"
                        [(ngModel)]="value"
                        (change)="onChange()"
                        (click)="onOpen()">
        </md2-datepicker>

        <div class="value" *ngIf="!!value">
            {{value|date: format}}
        </div>

        <mat-icon class="clear-icon" *ngIf="!!value" (click)="clearValue($event)" [style.color]="iconColor">
            clear
        </mat-icon>
    </div>
    <div *ngIf="!isDisplayErrorMessage">
        <span class="field_error">{{ errorText }}</span>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/date.time.field/date.field.component.html